import { render, staticRenderFns } from "./ops-links-grid.vue?vue&type=template&id=0151b919&scoped=true"
import script from "./ops-links-grid.vue?vue&type=script&lang=js"
export * from "./ops-links-grid.vue?vue&type=script&lang=js"
import style0 from "./ops-links-grid.vue?vue&type=style&index=0&id=0151b919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0151b919",
  null
  
)

export default component.exports